import type * as Types from '../../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { FileFieldsFragmentDoc } from '../../../graphql/gql-fragments/document.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlAgreementQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  companyId: Types.Scalars['String']['input'];
}>;


export type GqlAgreementQuery = { agreement: { id: string, name: string, delta: any, createdAt: string, templateName: string, isValid: boolean, status: Types.GqlAgreementFlowStatus, file: { id: string, companyId: string, mimeType: string, filename: string, filesize?: number | null, sha256?: string | null, signedFilesize?: number | null, signedSha256?: string | null, signatureMethod?: Types.GqlDocumentSignatureMethod | null, dirty: boolean, scriveMtime?: string | null, scriveCtime?: string | null, scriveStatus?: Types.GqlScriveDocumentStatus | null, scriveParties?: any | null, scriveTimeoutTime?: string | null, zignedAgreementStatus?: Types.GqlZignedAgreementStatus | null, signAllowedAction: Types.GqlSignAllowedAction, hasSignStatus: boolean, hasThumbnail: boolean, kind: Types.GqlDocSystemTagKind, groupId?: string | null, userTags?: Array<string> | null, genState: Types.GqlDocGenState, uploaded: boolean, reminderSentAt?: string | null, deletable: boolean, softDeletable: boolean, createdAt: string, updatedAt: string, sharedWithShareholders: boolean }, fields: Array<{ id: string, type: Types.GqlFieldType, name: string, longForm?: boolean | null, valueOptions?: Array<string> | null, value?: { id: string, value?: any | null, content?: any | null } | null }> } };

export type GqlUpsertValueMutationVariables = Types.Exact<{
  fieldId: Types.Scalars['String']['input'];
  valueString?: Types.InputMaybe<Types.Scalars['String']['input']>;
  valueDate?: Types.InputMaybe<Types.Scalars['Date']['input']>;
  valueBoolean?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  companyId: Types.Scalars['String']['input'];
  agreementId: Types.Scalars['String']['input'];
  valueIdentity?: Types.InputMaybe<Types.GqlCreateIdentityInput>;
}>;


export type GqlUpsertValueMutation = { upsertValue: { id: string } };

export type GqlGenerateAgreementPdfMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  companyId: Types.Scalars['String']['input'];
  signatureMethod: Types.GqlDocumentSignatureMethod;
}>;


export type GqlGenerateAgreementPdfMutation = { generateAgreementPdf: { id: string, name: string, file: { id: string, companyId: string, mimeType: string, filename: string, filesize?: number | null, sha256?: string | null, signedFilesize?: number | null, signedSha256?: string | null, signatureMethod?: Types.GqlDocumentSignatureMethod | null, dirty: boolean, scriveMtime?: string | null, scriveCtime?: string | null, scriveStatus?: Types.GqlScriveDocumentStatus | null, scriveParties?: any | null, scriveTimeoutTime?: string | null, zignedAgreementStatus?: Types.GqlZignedAgreementStatus | null, signAllowedAction: Types.GqlSignAllowedAction, hasSignStatus: boolean, hasThumbnail: boolean, kind: Types.GqlDocSystemTagKind, groupId?: string | null, userTags?: Array<string> | null, genState: Types.GqlDocGenState, uploaded: boolean, reminderSentAt?: string | null, deletable: boolean, softDeletable: boolean, createdAt: string, updatedAt: string, sharedWithShareholders: boolean } } };


export const AgreementDocument = gql`
    query Agreement($id: String!, $companyId: String!) {
  agreement(id: $id, companyId: $companyId) {
    id
    name
    delta
    createdAt
    templateName
    isValid
    status
    file {
      ...FileFields
    }
    fields {
      id
      type
      name
      longForm
      value {
        id
        value
        content
      }
      valueOptions
    }
  }
}
    ${FileFieldsFragmentDoc}`;

/**
 * __useAgreementQuery__
 *
 * To run a query within a React component, call `useAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgreementQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAgreementQuery(baseOptions: Apollo.QueryHookOptions<GqlAgreementQuery, GqlAgreementQueryVariables> & ({ variables: GqlAgreementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlAgreementQuery, GqlAgreementQueryVariables>(AgreementDocument, options);
      }
export function useAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlAgreementQuery, GqlAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlAgreementQuery, GqlAgreementQueryVariables>(AgreementDocument, options);
        }
export function useAgreementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlAgreementQuery, GqlAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlAgreementQuery, GqlAgreementQueryVariables>(AgreementDocument, options);
        }
export type AgreementQueryHookResult = ReturnType<typeof useAgreementQuery>;
export type AgreementLazyQueryHookResult = ReturnType<typeof useAgreementLazyQuery>;
export type AgreementSuspenseQueryHookResult = ReturnType<typeof useAgreementSuspenseQuery>;
export type AgreementQueryResult = Apollo.QueryResult<GqlAgreementQuery, GqlAgreementQueryVariables>;
export const UpsertValueDocument = gql`
    mutation UpsertValue($fieldId: String!, $valueString: String, $valueDate: Date, $valueBoolean: Boolean, $companyId: String!, $agreementId: String!, $valueIdentity: CreateIdentityInput) {
  upsertValue(
    fieldId: $fieldId
    valueString: $valueString
    valueDate: $valueDate
    valueBoolean: $valueBoolean
    companyId: $companyId
    agreementId: $agreementId
    valueIdentity: $valueIdentity
  ) {
    id
  }
}
    `;
export type GqlUpsertValueMutationFn = Apollo.MutationFunction<GqlUpsertValueMutation, GqlUpsertValueMutationVariables>;

/**
 * __useUpsertValueMutation__
 *
 * To run a mutation, you first call `useUpsertValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertValueMutation, { data, loading, error }] = useUpsertValueMutation({
 *   variables: {
 *      fieldId: // value for 'fieldId'
 *      valueString: // value for 'valueString'
 *      valueDate: // value for 'valueDate'
 *      valueBoolean: // value for 'valueBoolean'
 *      companyId: // value for 'companyId'
 *      agreementId: // value for 'agreementId'
 *      valueIdentity: // value for 'valueIdentity'
 *   },
 * });
 */
export function useUpsertValueMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpsertValueMutation, GqlUpsertValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpsertValueMutation, GqlUpsertValueMutationVariables>(UpsertValueDocument, options);
      }
export type UpsertValueMutationHookResult = ReturnType<typeof useUpsertValueMutation>;
export type UpsertValueMutationResult = Apollo.MutationResult<GqlUpsertValueMutation>;
export type UpsertValueMutationOptions = Apollo.BaseMutationOptions<GqlUpsertValueMutation, GqlUpsertValueMutationVariables>;
export const GenerateAgreementPdfDocument = gql`
    mutation GenerateAgreementPdf($id: String!, $companyId: String!, $signatureMethod: DocumentSignatureMethod!) {
  generateAgreementPdf(
    id: $id
    companyId: $companyId
    signatureMethod: $signatureMethod
  ) {
    id
    name
    file {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type GqlGenerateAgreementPdfMutationFn = Apollo.MutationFunction<GqlGenerateAgreementPdfMutation, GqlGenerateAgreementPdfMutationVariables>;

/**
 * __useGenerateAgreementPdfMutation__
 *
 * To run a mutation, you first call `useGenerateAgreementPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAgreementPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAgreementPdfMutation, { data, loading, error }] = useGenerateAgreementPdfMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      signatureMethod: // value for 'signatureMethod'
 *   },
 * });
 */
export function useGenerateAgreementPdfMutation(baseOptions?: Apollo.MutationHookOptions<GqlGenerateAgreementPdfMutation, GqlGenerateAgreementPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlGenerateAgreementPdfMutation, GqlGenerateAgreementPdfMutationVariables>(GenerateAgreementPdfDocument, options);
      }
export type GenerateAgreementPdfMutationHookResult = ReturnType<typeof useGenerateAgreementPdfMutation>;
export type GenerateAgreementPdfMutationResult = Apollo.MutationResult<GqlGenerateAgreementPdfMutation>;
export type GenerateAgreementPdfMutationOptions = Apollo.BaseMutationOptions<GqlGenerateAgreementPdfMutation, GqlGenerateAgreementPdfMutationVariables>;